import React from "react";
import { Link } from "react-router-dom";
import { getImageUrl } from "../../services/tmdbApi";
import './style.css';

// Pass 'movie' object as a prop to MovieCard component
const MovieCard = ({ movie }) => {
	if (!movie) {
		return null; // Return null if movie is not provided
	}

	// Determine if it is a movie or a TV show to link correctly
	const mediaType = movie.media_type === 'tv' ? 'tv' : 'movie';
	const title = movie.title || movie.name; // 'title' for movies, 'name' for TV shows
	const releaseDate = movie.release_date || movie.first_air_date;// for movies and TV shows

	return (
		<div className="movie-card">
			<Link to={`/${mediaType}/${movie.id}`}> {/* Link to the review page */}
				{movie.poster_path ? (
					<img
						src={getImageUrl(movie.poster_path, 'w300')} // w300 is the card size
						alt={title}
						className="movie-card-poster"
					/>
				) : (
					<div className="movie-card-no-image">No Image Available</div>
				)}
				<h3 className="movie-card-title">{title}</h3>
				{releaseDate && <p className="movie-card-date">{releaseDate.substring(0, 4)}</p>} {/* Display year only */}
			</Link>
		</div>
	);
}

// // Basic inline styles for now. Will move to CSS modules or a styling library later.
// const styles = {
// 	card: {
// 		border: '1px solid #ddd',
// 		borderRadius: '8px',
// 		padding: '10px',
// 		margin: '10px',
// 		width: '200px',
// 		textAlign: 'center',
// 		boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
// 		display: 'inline-block', // For a grid-like layout
// 		verticalAlign: 'top', // Align cards in a row
// 		textDecoration: 'none', // Remove underline from Link
// 		color: 'inherit', // Inherit color from parent
// 	},
// 	poster: {
// 		width: '100%',
// 		height: 'auto', // Fixed height for consistency
// 		objectFit: 'cover', // Cover the area, cropping if necessary
// 		borderRadius: '4px',
// 		marginBottom: '10px', // Space between image and text
// 	},
// 	noImage: {
// 		width: '100%',
// 		height: '300px', // Fixed height for no image placeholder
// 		backgroundColor: '#f0f0f0',
// 		display: 'flex',
// 		alignItems: 'center',
// 		justifyContent: 'center',
// 		color: '#888',
// 		borderRadius: '4px',
// 		marginBottom: '10px', // Space between placeholder and text
// 		fontSize: '0.9em',
// 	},
// 	title: {
// 		fontSize: '1.1em',
// 		margin: '5px 0',
// 		whiteSpace: 'nowrap', // Prevent text wrapping
// 		overflow: 'hidden', // Hide overflow text
// 		textOverflow: 'ellipsis', // Add ellipsis for overflow text
// 	},
// 	date: {
// 		fontSize: '0.9em',
// 		color: '#666',
// 	},
// }

export default MovieCard;